import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CROSS_PLATFORM_SIDEBAR_COLLABORATOR_TRANSLATION_KEY } from "../constants";
var en = /*#__PURE__*/_defineProperty({}, CROSS_PLATFORM_SIDEBAR_COLLABORATOR_TRANSLATION_KEY, {
  MODULE_HOME: 'Home',
  MODULE_RECOGNITION: 'Recognition',
  MODULE_PERFORMANCE: 'Performance',
  MODULE_CLIMATE: 'Climate',
  MODULE_LEARNING: 'E-Learning',
  MODULE_COMPANY: 'Company',
  MODULE_ANALYTICS: 'Analytics',
  MODULE_MY_TEAM: 'My team',
  MODULE_MY_RESULTS: 'My Results',
  TOOLTIP_CLIMATE_DESCRIPTION: "Measure your team's culture and satisfaction.",
  TOOLTIP_PERFORMANCE_DESCRIPTION: 'Evaluate performance through goals and competencies.',
  TOOLTIP_LEARNING_DESCRIPTION: "Manage learning strategies and enhance your team's skills.",
  TOOLTIP_RECOGNITION_DESCRIPTION: 'Manage badges awarded by collaborators.',
  TOOLTIP_COMPANY_DESCRIPTION: 'Monitor your processes and generate reports.',
  TOOLTIP_ANALYTICS_DESCRIPTION: 'Access the results of the processes you participate in.',
  TOOLTIP_MY_RESULTS_TITLE: 'Results',
  TOOLTIP_MY_RESULTS_DESCRIPTION: 'Analyze your results and those of the team you lead.',
  SUBMODULE_RESULTS_TITLE: 'My Results',
  SUBMODULE_TOOLTIP_MY_RESULTS_DESCRIPTION: 'Access the results of the processes you participate in',
  SUBMODULE_LEADER_RESULTS_TITLE: 'My Team',
  SUBMODULE_TOOLTIP_LEADER_RESULTS_DESCRIPTION: "Monitor your team's results",
  TOOLTIP_TITLE_MY_RESULTS: 'My Results',
  TOOLTIP_DESCRIPTION_MY_RESULTS: 'Check the results of the processes in which you participate.',
  TOOLTIP_TITLE_MODULE_MY_TEAM: 'My Team',
  TOOLTIP_DESCRIPTION_MODULE_MY_TEAM: 'Monitor the active processes and results of your team.',
  SUBMODULE_ACTIVE_PROCESSES: 'Follow up',
  SUBMODULE_TOOLTIP_ACTIVE_PROCESSES_DESCRIPTION: 'Manage your team’s participation in a centralized way.',
  SUBMODULE_MY_TEAM_RESULTS: 'Results',
  TOOLTIP_DESCRIPTION_SUBMODULE_MY_TEAM_RESULTS: 'Analyze the results of completed processes.',
  SUBMODULE_DIRECTORY_TITLE: 'Directory',
  SUBMODULE_TOOLTIP_DIRECTORY_DESCRIPTION: 'Information about company members',
  SUBMODULE_COMPANY_CHART_TITLE: 'Company Chart',
  SUBMODULE_COMPANY_CHART_DESCRIPTION: "Get to know the company's structure",
  SUBMODULE_RECOGNITION_TITLE: 'Badges',
  SUBMODULE_TOOLTIP_RECOGNITION_DESCRIPTION: 'Send badges to your colleagues and see the ones you received',
  SUBMODULE_RECOGNITION_REDEMPTION_TITLE: 'Rewards',
  SUBMODULE_TOOLTIP_RECOGNITION_REDEMPTION_DESCRIPTION: 'Redeem the points you earned for your achievements',
  SUBMODULE_OKRS_PERFORMNACE_TITLE: 'OKRs',
  SUBMODULE_TOOLTIP_OKRS_PERFORMANCE_DESCRIPTION: 'Visualize the progress of the business strategy and recognize the effort to achieve the objectives',
  SUBMODULE_GOALS_TITLE: 'Goals',
  SUBMODULE_TOOLTIP_GOALS_DESCRIPTION: 'Plan and set your work commitments',
  SUBMODULE_COMPETENCES_TITLE: 'Evaluations',
  SUBMODULE_TOOTLTIP_COMPETENCES_DESCRIPTION: 'Access the questionnaires of the assigned processes',
  SUBMODULE_FEEDBACK_TITLE: 'Feedback',
  SUBMODULE_TOOLTIP_FEEDBACK_DESCRIPTION: "Measure your company's feedback processes.",
  SUBMODULE_PID_TITLE: 'Individual Development Plan',
  SUBMODULE_TOOLTIP_PID_DESCRIPTION: 'Create processes to close gaps and promote growth.',
  SUBMODULE_SUCESSION_PLAN_TITLE: 'Succession Plan',
  SUBMODULE_TOOLTIP_SUCESSION_PLAN_DESCRIPTION: 'Create action plans for future vacancies.',
  SUBMODULE_CLIMATE_EVALUATION_TITLE: 'Climate Evaluations',
  SUBMODULE_TOOLTIP_CLIMATE_EVALUATION_DESCRIPTION: 'Access the questionnaire to mediate organizational climate',
  SUBMODULE_SURVEY_TITLE: 'Surveys',
  SUBMODULE_TOOLTIP_SURVEY_DESCRIPTION: 'Help your company collect information quickly and easily',
  // Learning links
  LEARNING_LINK_LEARND_AND_PROGRESS: 'LEARNING AND PROGRESS',
  LEARNING_LINK_MORE_FOR_YOU: 'More content',
  LEARNING_LINK_ENROLLED_COURSES: 'Courses',
  LEARNING_LINK_TOOLTIP_MORE_FOR_YOU_DESCRIPTION: 'Discover new learning content',
  LEARNING_LINK_PATHS: 'Learning paths',
  LEARNING_LINK_LIVE_SESSIONS: 'Live sessions',
  LEARNING_LINK_NOTES: 'Notes',
  LEARNING_LINK_STUDY_PLAN: 'Study plan',
  LEARNING_LINK_TOOLTIP_STUDY_PLAN: 'Plan your learning goal',
  LEARNING_LINK_MENTORSHIP: 'Mentorship',
  LEARNING_LINK_TOOLTIP_MENTORSHIP: 'Request advice from specialists',
  LEARNING_LINK_BLOG: 'Blog',
  LEARNING_LINK_LIVES: 'Lives',
  LEARNING_LINK_TOOLS: 'Tools',
  LEARNING_LINK_EVALUATIONS_AND_GOALS: 'EVALUATION AND ACHIEVEMENTS',
  LEARNING_LINK_SKILL_XP: 'Skill XP',
  LEARNING_LINK_PROJECTS: 'Projects',
  LEARNING_LINK_TOOLTIP_PROJECTS_DESCRIPTION: 'Carry out the projects of your courses',
  LEARNING_LINK_DIPLOMA: 'Diplomas',
  LEARNING_LINK_TOOLTIP_DIPLOMA_DESCRIPTION: 'Check the diplomas obtained for completing your learning',
  LEARNING_LINK_PENDING_TESTS: 'Pending tests',
  LEARNING_LINK_DONE_TESTS: 'Completed tests',
  LEARNING_LINK_ACCHIEVEMENTS: 'Achievements',
  LEARNING_LINK_REWARDS: 'Rewards',
  LEARNING_LINK_SKILL_XP_EVOLUTION: 'Skill XP Evolution',
  LEARNING_LINK_TOOLTIP_SKILL_XP_EVOLUTION_DESCRIPTION: 'Take tests and identify the level of your skills',
  LEARNING_LINK_GAMIFICATION: 'Gamification',
  LEARNING_LINK_TOOLTIP_GAMIFICATION_DESCRIPTION: 'Earn rewards for your learning achievements',
  LEARNING_LINK_MY_COURSES: 'My courses',
  LEARNING_LINK_TOOLTIP_MY_COURSES_DESCRIPTION: 'Access courses and paths you are enrolled in',
  LEARNING_LINK_RESOURCES: 'Resources',
  LEARNING_LINK_TOOLTIP_RESOURCES_DESCRIPTION: 'Learning resources',
  LEARNING_LINK_COURSES: 'Courses',
  LEARNING_LINK_DISCOVER: 'Discover',
  LEARNING_LINK_KNOWLEDGE_HUB: 'Catalog',
  // Misc
  SIDEBAR_BACK: 'Back',
  SIDEBAR_BACK_TO_PRODUCTS: 'Back to my products',
  SIDEBAR_EXPAND: 'Expand menu',
  SIDEBAR_COLLAPSE: 'Collapse menu',
  SIDEBAR_HELP: 'Help',
  SIDEBAR_HELP_DESCRIPTION: 'Access resources and support channel.',
  MODULE_PRODUCTS_SUBTITLE: 'PRODUCTS'
});
export default en;